namespace advisorop.components.servicer {

    class MeetingHupWrapperController {
        createMeeting: boolean = true;
        //$scope: ng.IScope;

        static $inject = ["$scope"];
        constructor(private $scope: ng.IScope) {
        }

        onCreateMeeting(): void {
            this.createMeeting = !this.createMeeting;
            this.$scope.$apply();
        }

        $onInit(): void {
        }

    }

    class MeetingHupWrapper implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = MeetingHupWrapperController;
            this.controllerAs = `vm`;
            this.templateUrl = `spa/servicer-module/components/meeting-hup-wrapper.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingHupWrapper`, new MeetingHupWrapper());
}